import { Component, OnInit, Input } from '@angular/core';

import { WellSegmentModel, CasingType } from "../../../new-casing-plan/models/casing-plan.model";
import { isDefined } from "../../../new-casing-plan/models/casing-plan-functions.model";

import { CasingPlan2dBaseComponent } from "../casing-plan-2d-base.component";

@Component({
    selector: 'casing-plan-2d-detail-base',
    template: '',
    standalone: false
})

export class CasingPlan2dDetailBaseComponent extends CasingPlan2dBaseComponent implements OnInit {

    canvasHeight: number; 
    canvasMarginTop: number = 100;

    casingLength: number;
    casingPercent: number;
    center: number;
    ctx: CanvasRenderingContext2D;
    diagramCasingWidth: number = 20;
    factorFeetToPixels: number;
    font: string = "12px Work Sans";
    fontFileStyle: string = "#000000";
    groundLineWidth: number = 20;
    innerCasingLineWidth: number = 3;
    leftArrow: HTMLImageElement = new Image();
    leftBorehole: number;
    leftCasing: number;
    rightArrow: HTMLImageElement = new Image();
    rightBorehole: number;
    rightCasing: number;
    radius: number = 80;             //radius of the larger (left) curve
    _curveMargin: number;            //space below the bottom of the curve
    labelPadding: number = 6;        //space between linework/rectangles and the label 
    cementFillColor = "#888888";                //standard cement fill color
    aryKickpoint = [];
    get curveMargin(): number {
        return this.bottomCanvasMarginPx * .6;
    }
    set curveMargin(value: number) {
        this._curveMargin = value;
    }
    marginRight: number = 40;        //stop here for rendering well end
    barWidth = 20;                  //width of curved casing
    _bottomMargin: number;
    get bottomCanvasMarginPx(): number {
        return this._bottomMargin;
    }
    set bottomCanvasMarginPx(value: number) {
        this._bottomMargin = value;
    }

    @Input() segment: WellSegmentModel;
    @Input() length: any;
    @Input() segmentIndex: number;
    @Input() applicationData: any;

    

    constructor() {
        super();
    }

    ngOnInit() {
    }

    /**
     * Adds solid white background for PDF generation
     * @param canvasHeight
     * @param canvasWidth
     */
    addWhiteBackground(canvasHeight?: number, canvasWidth?: number): void {
        this.ctx.fillStyle = "#ffffff";
        if (!canvasHeight || !canvasWidth) {
            this.ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
        } else {
            this.ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        }
    }

    /**
     * Fills bottom of string with cement
     * @param segment
     */
    addCementBottom(segment: WellSegmentModel): void {
        let cementHeight = 20;
        this.ctx.fillStyle = this.cementFillColor;
        this.ctx.beginPath();
        this.ctx.fillRect(
            this.leftCasing - this.innerCasingLineWidth,
            this.canvasHeight - cementHeight,
            (this.rightCasing + 2 * this.innerCasingLineWidth) - this.leftCasing,
            cementHeight);
        this.ctx.closePath();
        //potential future requested changes
        //y to casing length = this.casingLength - this.shoeHW
        //height to casing = (this.canvasHeight + this.shoeHW) - this.casingLength)
    }
    /**
     * Add casing lines
     * @param segment
     */
    addCasing(segment: WellSegmentModel): void {

            this.ctx.beginPath();

            //top of casing
            this.ctx.font = this.font;
            this.ctx.fillStyle = this.fontFileStyle;            
            this.ctx.fillText("Top of " + segment.casingDiameter + " IN. Casing: " + segment.casingTop + " FT.", this.rightBorehole + this.groundLineWidth + this.labelPadding, this.canvasMarginTop + 4);

            //bottom of casing
            this.ctx.font = this.font;
            this.ctx.fillStyle = this.fontFileStyle;
            this.ctx.fillText("Bottom of " + segment.casingDiameter + " IN. Casing: " + segment.casingBottom + " FT.", this.rightBorehole + this.groundLineWidth + this.labelPadding, this.casingLength);

            //need to calculate casing height for this.casingHeight
            this.ctx.moveTo(this.rightCasing, this.canvasMarginTop);
            this.ctx.lineWidth = this.innerCasingLineWidth;
            this.ctx.lineTo(this.rightCasing, this.casingLength);
            this.ctx.stroke();

            //need to calculate casing height for this.casingHeight
            this.ctx.moveTo(this.leftCasing, this.canvasMarginTop);
            this.ctx.lineWidth = this.innerCasingLineWidth;
            this.ctx.lineTo(this.leftCasing, this.casingLength);
            this.ctx.stroke();

            this.ctx.closePath();
    }

    /**
     * Sets var for calulating vertical feet to pixels
     * @param segment
     */
    setfeetToPixelFactor(segment: WellSegmentModel): void {
        let segmentLength: number = 0;
        if (this.hasBorehole(segment)) {
            segmentLength = segment.boreholeBottom - segment.boreholeTop;
        } else if (this.hasCasing(segment)) {
            segmentLength = segment.casingBottom - segment.casingTop;
        } else {
            return;
        }        
        //calc percentage for converting feet to pixels
        let diagramLength = this.canvasHeight - this.canvasMarginTop;
        this.factorFeetToPixels = diagramLength / segmentLength;
    }

    /**
     * Outermost string line
     * @param segment
     */
    addBoreHole(segment: WellSegmentModel): void {
        /* outer stroke on cement */

        //right
        this.ctx.beginPath();
        this.ctx.moveTo(this.rightBorehole, this.canvasMarginTop);
        this.ctx.lineWidth = 1;
        this.ctx.lineTo(this.rightBorehole, this.canvasHeight);
        this.ctx.closePath();
        this.ctx.stroke();

        //left
        this.ctx.beginPath();
        this.ctx.moveTo(this.leftBorehole, this.canvasMarginTop);
        this.ctx.lineWidth = 1;
        this.ctx.lineTo(this.leftBorehole, this.canvasHeight);
        this.ctx.closePath();
        this.ctx.stroke();

        //top label
        // left label position depends on if we are drawing the left ground rectangle
        let topLabelLeftLocation: number = this.leftBorehole - this.labelPadding;
        if (this.segmentIndex == 0) {
            topLabelLeftLocation -= this.groundLineWidth;
        }

        this.ctx.font = this.font;
        this.ctx.fillStyle = this.fontFileStyle;
        this.ctx.textAlign = "right";
        if (this.hasBorehole(this.segment)) {
            this.ctx.fillText("Top of " + segment.boreholeDiameter + " IN. Hole: " + segment.boreholeTop + " FT.", topLabelLeftLocation, this.canvasMarginTop + 4);
        }
        

        //bottom label
        this.ctx.font = this.font;
        this.ctx.fillStyle = this.fontFileStyle;
        if (this.hasBorehole(this.segment)) {
            if (segment.casingType.definition !== CasingType.MineString) {
                this.ctx.fillText("Bottom of " + segment.boreholeDiameter + " IN. Hole: " + segment.boreholeBottom + " FT.", this.leftBorehole - (this.groundLineWidth + this.labelPadding), this.canvasHeight);
            } else {
                //draw hole bottom at casing if Mine String
                this.ctx.fillText("Bottom of " + segment.boreholeDiameter + " IN. Hole: " + segment.boreholeBottom + " FT.", this.leftBorehole - (this.groundLineWidth + this.labelPadding), this.casingLength)
            }
        }
       

        //reset alignment for the rest of the diagram
        this.ctx.textAlign = "left";
        this.ctx.closePath();
    }


    /**
     * Draw "ground" or bottom of last borehole
     * @param segmentIndex
     */
    addGround(segmentIndex: number): void {
        this.ctx.beginPath();
        this.ctx.fillStyle = "#000000";

        //right rectangle for ground
        this.ctx.fillRect(this.rightBorehole - 1, this.canvasMarginTop, this.groundLineWidth, 5);

        //segmentIndex is "0" based!
        //are we one the first segment?
        if (segmentIndex == 0) {
            //left rectangle for ground
            this.ctx.fillRect((this.leftBorehole - this.groundLineWidth + 1), this.canvasMarginTop, this.groundLineWidth, 5);
        }

        this.ctx.closePath();
    }

    /**
     * Cement fill and top label
     * @param segment
     */
    addCementFillingAndLabels(segment: WellSegmentModel): void {

        //fill the cement with gray
        this.ctx.fillStyle = this.cementFillColor;

        //placement on canvas
        let cementTopPx;
        let cementBottomPx;

        //does cement start before the borehole top?
        if (this.isBeyondCurrentString(segment.cementTop, true)) {
            //set to top of the borehole
            cementTopPx = this.canvasMarginTop;
        } else {
            cementTopPx = ((segment.cementTop - this.segment.boreholeTop) * this.factorFeetToPixels) + this.canvasMarginTop;

        }

        //does cement end after the borehole bottom?
        if (this.isBeyondCurrentString(segment.cementBottom, false)) {
            cementBottomPx = this.canvasHeight;
        } else {
            cementBottomPx = ((segment.cementBottom - this.segment.boreholeTop) * this.factorFeetToPixels) + this.canvasMarginTop;
        }


        let localRightBorehole = this.rightBorehole;
        //calc diff for height - fillRect uses height not x/y location!
        let heightPx = cementBottomPx - cementTopPx;

        this.ctx.beginPath();
        this.ctx.fillRect(this.rightCasing + 2, cementTopPx, 17, heightPx);
        this.ctx.fillRect(this.leftBorehole + 1, cementTopPx, 17, heightPx);

        //make sure the labels don't run together
        if (cementTopPx < 120) {
            //if fractored top is less then 120, it will overwrite the top of casing
            cementTopPx = 120;
            //move label out in line with top of casing label
            localRightBorehole += this.groundLineWidth;
        }
        //top of cement label
        this.ctx.font = this.font;
        this.ctx.fillStyle = this.fontFileStyle;
        this.ctx.fillText("Top of Cement: " + segment.cementTop + " FT.", localRightBorehole + 6, cementTopPx);

        this.ctx.closePath();

    }

    /**
     * Bottom of the well
     * @param segment
     */
    addSegmentBottom(segment: WellSegmentModel): void {
        this.ctx.beginPath();
        this.ctx.moveTo((this.leftBorehole - this.groundLineWidth), this.canvasHeight);
        this.ctx.lineTo((this.rightBorehole + this.groundLineWidth), this.canvasHeight);
        this.ctx.stroke();
        this.ctx.closePath();
    }

    /**
     * Casing and borehole diameter arrows
     * @param segment
     */
    addDiameterArrows(segment: WellSegmentModel): void {
        let boreholeArrowLineTop = 30;
        let casingArrowLineTop = 70;
        let arrowHeight = 12;
        let halfArrowHeight = arrowHeight * .5;
        let inch = "IN.";
        let fourteenPxVerticalOffset = 4;
        let labelMarginLeft = 6;

        if (isDefined(this.segment.boreholeDiameter)) {
            //draw borehole line
            this.ctx.beginPath();
            this.ctx.lineWidth = 1
            this.ctx.moveTo(this.leftBorehole, boreholeArrowLineTop);
            this.ctx.lineTo(this.rightBorehole, boreholeArrowLineTop);
            this.ctx.stroke();
            this.ctx.closePath();
        }
       

        //draw borehole and casing left arrows
        this.leftArrow.onload = () => {
            if (isDefined(this.segment.boreholeDiameter)) {
                this.ctx.drawImage(this.leftArrow, this.leftBorehole, boreholeArrowLineTop - halfArrowHeight, arrowHeight, arrowHeight);
            }
            if (isDefined(this.segment.casingDiameter)) {
                this.ctx.drawImage(this.leftArrow, this.leftCasing, casingArrowLineTop - halfArrowHeight, arrowHeight, arrowHeight);
            }            
        };

        //draw borehole and casing right arrows
        this.rightArrow.onload = () => {
            if (isDefined(this.segment.boreholeDiameter)) {
                this.ctx.drawImage(this.rightArrow, this.rightBorehole - arrowHeight, boreholeArrowLineTop - halfArrowHeight, arrowHeight, arrowHeight);
            }
            if (isDefined(this.segment.casingDiameter)) {
                this.ctx.drawImage(this.rightArrow, this.rightCasing - arrowHeight, casingArrowLineTop - halfArrowHeight, arrowHeight, arrowHeight);
            }            
        };

        if (isDefined(this.segment.casingDiameter)) {
            //draw casing line
            this.ctx.beginPath();
            this.ctx.moveTo(this.leftCasing, casingArrowLineTop);
            this.ctx.lineTo(this.rightCasing, casingArrowLineTop);
            this.ctx.stroke();
            this.ctx.closePath();
        }       

        this.ctx.font = this.font;
        this.ctx.textAlign = "left";
        this.ctx.fillStyle = "#474747";
        if (isDefined(this.segment.boreholeDiameter) && segment.boreholeDiameter.toString().trim() !== "") {
            this.ctx.fillText("Borehole: " + segment.boreholeDiameter.toFixed(3) + " " + inch, this.rightBorehole + labelMarginLeft, boreholeArrowLineTop + fourteenPxVerticalOffset);
        }
        if (isDefined(this.segment.casingDiameter) && segment.casingDiameter.toString().trim() !== "") {
            this.ctx.fillText("Casing Outside: " + segment.casingDiameter.toFixed(3) + " " + inch, this.rightBorehole + labelMarginLeft, casingArrowLineTop + fourteenPxVerticalOffset);
        }       
    }

    /**
     * Vertical dashed lines for casing & borehole
     */
    addDashedLines(): void {
        this.ctx.fillStyle = "#000000";
        this.ctx.strokeStyle = '#000000';
        this.ctx.lineWidth = 1;

        if (isDefined(this.segment.boreholeDiameter) && this.segment.boreholeDiameter.toString().trim() !== "") {
            //left borehole
            this.ctx.beginPath();
            this.ctx.moveTo(this.leftBorehole, this.canvasMarginTop - 5);
            this.ctx.lineTo(this.leftBorehole, 20);
            this.ctx.setLineDash([5, 5]);
            this.ctx.stroke();
            this.ctx.closePath();

            //right borehole
            this.ctx.beginPath();
            this.ctx.moveTo(this.rightBorehole, this.canvasMarginTop - 5);
            this.ctx.lineTo(this.rightBorehole, 20);
            this.ctx.setLineDash([5, 5]);
            this.ctx.stroke();
            this.ctx.closePath();
        }        

        //left casing
        if (isDefined(this.segment.casingDiameter) && this.segment.casingDiameter.toString().trim() !== "") {
            this.ctx.beginPath();
            this.ctx.moveTo(this.leftCasing, this.canvasMarginTop - 5);
            this.ctx.lineTo(this.leftCasing, this.canvasMarginTop - 40);
            this.ctx.stroke();
            this.ctx.closePath();

            //right casing
            this.ctx.beginPath();
            this.ctx.moveTo(this.rightCasing, this.canvasMarginTop - 5);
            this.ctx.lineTo(this.rightCasing, this.canvasMarginTop - 40);
            this.ctx.stroke();
            this.ctx.closePath();
        }
       
    }
    /**
     * Gets first kick point in segment
     */
    getFirstSegmentKickpoint(): any {
        if (this.segment && this.segment.hasAngles) {
            const top: number = (this.segment.casingTop != null) ? this.segment.casingTop : this.segment.boreholeTop;
            const bottom: number = (this.segment.casingBottom != null) ? this.segment.casingBottom : this.segment.boreholeBottom;
            if (top != null && bottom != null) {
                return (bottom - top) / 2; //exact position doesn't matter to the drawing; assume its at the halfway point
            }
            return undefined;
        } else {
            return undefined;
        }
        return undefined;
    }

    isBeyondCurrentString(value: number, above: boolean): boolean {
        if (above) {
            return value < this.segment.boreholeTop;
        } else {
            return value > this.segment.boreholeBottom;;
        }
    }
}